import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import experiments from '@reverbdotcom/commons/src/experiments';
import { experimentInt } from '@reverbdotcom/commons/src/user_context_helpers';
import { COUNTRY_CODES } from '../../shared/constants';
import { PageSettings } from './map_params';

const CONTROL_GROUP = 0;

export function bestMatchSignalsExperimentGroup(user: Partial<IUser>, pageSettings: PageSettings) {
  if (user.countryCode !== COUNTRY_CODES.US) {
    return CONTROL_GROUP;
  }

  if (pageSettings.useExperimentalBestMatchSignals === false) {
    return CONTROL_GROUP;
  }

  return experimentInt(user, experiments.LISTINGS_SEARCH_BEST_MATCH_SIGNALS_V3);
}

export function likelihoodToSellExperimentGroup(user: Partial<IUser>, pageSettings) {
  if (user.countryCode !== COUNTRY_CODES.US) {
    return CONTROL_GROUP;
  }

  if (pageSettings.useExperimentalBestMatchSignals === false) {
    return CONTROL_GROUP;
  }

  return experimentInt(user, experiments.LISTINGS_SEARCH_LIKELIHOOD_TO_SELL);
}
